import axios from 'axios'

// Use environment variable for API URL, fallback to relative path for dev proxy
const baseURL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL,
  timeout: 120000,  // 2 min timeout for Claude API calls
})

// Add request interceptor for debugging
api.interceptors.request.use(
  (config) => {
    // Log requests in development
    if (import.meta.env.DEV) {
      console.log(`[API] ${config.method?.toUpperCase()} ${config.url}`)
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if offline
    if (!navigator.onLine) {
      error.isOffline = true
      error.message = 'You are offline. This action requires an internet connection.'
    }
    return Promise.reject(error)
  }
)

export default api
